import React, { useEffect, useState } from 'react';
import styled from 'astroturf/react';

import routes from 'js/core_pre_webpack/routes';
import fetchWithCsrf from 'js/utils/fetch_with_csrf';

import { Icon } from 'js/design_system/Icon';
import { Body } from 'js/design_system/Body';
import _MetricInner from "UngatedWorkCardDownloadCount-MetricInner.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/single_work/loswp/UngatedWorkCardDownloadCount.tsx?styleId=MetricInner";


const MetricInner = /*#__PURE__*/styled("div", null, {
  displayName: "MetricInner",
  styles: _MetricInner
});

type Props = { workId: number };

export function UngatedWorkCardDownloadCount({ workId }: Props) {
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    let cancelled = false;
    const url = routes.api_v0_work_download_count_path({
      work_id: workId,
      subdomain_param: 'api',
    });

    fetchWithCsrf(url)
      .then((res) => (res.ok ? res.json() : undefined))
      .then((data: { count?: number } | undefined) => {
        if (!cancelled && data && typeof data.count === 'number') {
          setCount(data.count);
        }
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [workId]);

  if (count === null) return null;

  return (
    <MetricInner>
      <Icon
        name="download"
        size={16}
        className="ungated-work-card--metric-icon"
      />
      <Body size="md" className="ungated-work-card--metric-number">
        {count.toLocaleString()}
      </Body>
      <Body size="xs" className="ungated-work-card--metric-label">
        {count === 1 ? 'download' : 'downloads'}
      </Body>
    </MetricInner>
  );
}
